import React from 'react';
import { Briefcase, TrendingUp, BookOpen, Umbrella, Cpu, Target, ArrowRight } from 'lucide-react';
import { SERVICES } from '../mock';

const iconMap = { Briefcase, TrendingUp, BookOpen, Umbrella, Cpu, Target };

const Services = () => {
  return (
    <section id="services" className="py-24 bg-[#f6f9fc]">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="text-center mb-16">
          <p className="eyebrow mb-3">WHAT WE DO</p>
          <h2 className="section-title text-4xl md:text-5xl">We make it easy</h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s) => {
            const Icon = iconMap[s.icon];
            return (
              <div key={s.id} className="service-card rounded-xl p-8 flex flex-col">
                <div className="service-icon-wrap mb-6">
                  <Icon size={28} />
                </div>
                <h3 className="service-title text-[#0a2c4d] font-bold text-lg tracking-wider mb-3">{s.title}</h3>
                <p className="service-desc text-[#556a85] text-[15px] leading-relaxed mb-6 flex-1">{s.desc}</p>
                <a href={`#${s.id}`} className="inline-flex items-center gap-2 text-[#0a6cb0] font-semibold text-sm uppercase tracking-wider group">
                  Select <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
